import { render } from "./iconMensaje.vue?vue&type=template&id=696a2ae7&scoped=true"
import script from "./iconMensaje.vue?vue&type=script&lang=js"
export * from "./iconMensaje.vue?vue&type=script&lang=js"

import "./iconMensaje.vue?vue&type=style&index=0&id=696a2ae7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-696a2ae7"

export default script